<span [formGroup]="formgroup!">
    <mat-checkbox [formControl]="warningFC!" class="warning-checkbox" *ngIf="!(suspiciousContractsLoading$ | async);else loading">
        {{ t7eLabel }}
    </mat-checkbox>
</span>

<ng-template #loading>
  <div class="d-flex warning-loading">
    <mat-spinner diameter="20" class="mr-05"></mat-spinner>
    <span class="unimportant">{{ t7eLoadingLabel }}</span>
  </div>
</ng-template>
